var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoRadioChecked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.48103 18.1245C7.72189 18.1245 6.00226 17.6036 4.53959 16.6277C3.07692 15.6518 1.93691 14.2646 1.26372 12.6417C0.590524 11.0188 0.414386 9.23306 0.757576 7.5102C1.10077 5.78734 1.94787 4.2048 3.19177 2.96269C4.43567 1.72058 6.02049 0.874687 7.74582 0.531989C9.47116 0.189291 11.2595 0.365176 12.8847 1.0374C14.51 1.70963 15.8991 2.848 16.8764 4.30857C17.8537 5.76914 18.3754 7.4863 18.3754 9.24291C18.3728 11.5977 17.4348 13.8552 15.7674 15.5203C14.0999 17.1853 11.8392 18.1219 9.48103 18.1245ZM4.50908 7.99061L3.25498 9.24291L7.70216 13.6837L15.7071 5.69028L14.453 4.4291L7.70216 11.1702L4.50908 7.99061Z",
    fill: "#00263E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoRadioChecked);
export default __webpack_public_path__ + "static/media/icoRadioChecked.c5440773c056bc5286f1efe83be80bf5.svg";
export { ForwardRef as ReactComponent };